import { Children, isValidElement } from 'react';
export function createNamespace(name, prefix) {
  return (prefix || 'bxl') + "-" + name;
}
export function isFunction(val) {
  return typeof val === 'function';
}
export function isDef(val) {
  return val !== undefined && val !== null;
}
export function parseChildList(children) {
  return Children.toArray(children).map(function (node) {
    if ( /*#__PURE__*/isValidElement(node)) {
      var key = node.key !== undefined ? String(node.key) : undefined;
      return Object.assign(Object.assign({
        key: key
      }, node.props), {
        node: node
      });
    }
    return null;
  }).filter(function (child) {
    return child;
  });
}
export function isObject(val) {
  return val !== null && typeof val === 'object';
}
export function isPromise(val) {
  return isObject(val) && isFunction(val.then) && isFunction(val.catch);
}
export function callInterceptor(options) {
  var interceptor = options.interceptor,
    args = options.args,
    done = options.done,
    canceled = options.canceled;
  if (interceptor) {
    // eslint-disable-next-line prefer-spread
    var returnVal = interceptor.apply(null, args || []);
    if (isPromise(returnVal)) {
      returnVal.then(function (value) {
        if (value) {
          done();
        } else if (canceled) {
          canceled();
        }
      }).catch(function () {});
    } else if (returnVal) {
      done();
    } else if (canceled) {
      canceled();
    }
  } else {
    done();
  }
}
export function depsAreSame(oldDeps, deps) {
  if (oldDeps === deps) return true;
  for (var i = 0; i < oldDeps.length; i++) {
    if (!Object.is(oldDeps[i], deps[i])) return false;
  }
  return true;
}